module.exports = __webpack_public_path__ + "assets/img/龙航宇.812b4b9d.jpg";